<!--  Top menu -->
<nav id="mainNav" class="navbar navbar-expand-md navbar-dark fixed-top" [ngStyle]="headerStyle">
	<div class="container">
		<a class="navbar-brand" [routerLink]="defaultUrl" routerLinkActive="active-link">
			<img  *ngIf="logoPath" [src]="logoPath" class="img-fluid main-logo">
		</a>
		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="true" aria-label="Toggle navigation">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124 105" width="124" height="105">
        <!-- <style>
          tspan { white-space:pre }
          .shp0 { fill: {{hamburgerColor}} }
        </style> -->
        <path id="Shape 2" class="shp0" d="M0 0L124 0L124 17.87L0 17.87L0 0Z"/>
        <path id="Shape 2 copy" class="shp0" d="M0 43.98L124 43.98L124 61.85L0 61.85L0 43.98Z"/>
        <path id="Shape 2 copy 2" class="shp0" d="M0 87.13L124 87.13L124 105L0 105L0 87.13Z"/>
      </svg>
		</button>
		<div class="collapse navbar-collapse" id="navbarCollapse" *ngIf="!isMaintenance">
			<ul menuToggleDirective id="main" class="navbar-nav ml-auto main-menu list-unstyled">
				<li menuToggleLink class="nav-item" routerLinkActive="open" *ngFor="let menuItem of menuItems">
					<a menuToggle class="nav-link" [routerLink]="menuItem.state" [ngStyle]="itemStyle"   routerLinkActive="active-link" *ngIf="menuItem.type == 'link'" (click)="removeCollapseInClass()">
						{{ menuItem?.name }}
					</a>
          <a menuToggle class="nav-link" href="{{menuItem.state}}" [ngStyle]="itemStyle"   routerLinkActive="active-link" [target]="getTargetValue(menuItem.type)" *ngIf="menuItem.type == 'external'"  (click)="removeCollapseInClass()">
            {{ menuItem?.name }}
          </a>
					<a menuToggle *ngIf="menuItem.type == 'sub'" class="nav-link" href="javascript:void(0)">{{ menuItem?.name }}&nbsp;
						<i class="{{ menuItem?.icon }}"></i>
					</a>
					<ul *ngIf="menuItem.type == 'sub' && menuItem?.children" class="sub-menu arrow-up list-unstyled" >
						<li class="nav-item" routerLinkActive="open" *ngFor="let grandchildItem of menuItem?.children">
							<a class="nav-link" [routerLink]="['/', grandchildItem.state]" routerLinkActive="active-link" *ngIf="grandchildItem.type == 'link'" (click)="removeCollapseInClass()">
								{{ grandchildItem?.name }}
							</a>
						</li>
					</ul>
				</li>
				<li>
<!--					<div class="search-form" click-outside (clickOutside)="onClickOutside($event)">-->
<!--						<span data-target="#search-style-simple" (click)="searchActiveFunction()">-->
<!--							<i class="fa fa-search"></i>-->
<!--						</span>-->
<!--						<div class="module-container" [ngClass]="{'search-active': searchActive}" id="search-style-simple">-->
<!--							<form role="search" method="get" class="search-box" action="javascript:void(0);">-->
<!--								<input type="search" class="form-control" placeholder="Search" value="" name="" />-->
<!--								<button type="submit"><i class="fa fa-search"></i></button>-->
<!--							</form>-->
<!--						</div>&lt;!&ndash; /module-container &ndash;&gt;-->
<!--					</div>&lt;!&ndash; /module &ndash;&gt;-->
				</li>
			</ul>
		</div>
	</div>
</nav>
